/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import './styles.scss'
import { TypescriptComponent } from 'components/typescriptExample'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import { ArticleTeasers } from '@ta-interaktiv/react-article-teasers'
import Stack from 'components/stack'
import Subtitle from 'components/subtitle'

import { TEXT_FR } from '../_text_fr'
import { TEXT_DE } from '../_text_de'

const LOCALE = 'DE'
//
const ARTICLE_ID_DE = '603166895095'
const ARTICLE_ID_FR = '000000000000'
const ARTICLE_ID = LOCALE === 'DE' ? ARTICLE_ID_DE : ARTICLE_ID_FR
//
const TEXT = LOCALE === 'DE' ? TEXT_DE : TEXT_FR

const isMobile = window.innerWidth < 600

export function AppComponent() {
  return (
    <div className='index'>
      <Masthead articleId={ARTICLE_ID} />
      <ThemeSwitch />

      <header className='ui vertical  very relaxed  segment cover'>
        <div className='ui container'>
          <div className='ui header'>
            <h1>{TEXT.title}</h1>
            <h2>{TEXT.lead}</h2>
          </div>
        </div>
      </header>

      <div className='ui vertical segment'>
        <div className='ui text container'>
          <div className='ta metainfo'>
            <div className='ta author'>
              Bernhard Odehnal, Sylvain Besson, Svenson Cornehls
            </div>
            <div className='ta updated'>{TEXT.updated}</div>
          </div>
          <div className='ta text'>{TEXT.intro}</div>
        </div>
      </div>

      <div className='subtitle ui vertical segment'>
        <div className='ui text container'>
          <div className='ta text'>
            <Subtitle
              color='#E78D38'
              title={TEXT.titleA}
              category='A'
              angle='5'
            />
          </div>
          <div className='ta text'>{TEXT.textA}</div>
          <Stack category='A' lang={LOCALE} />
        </div>
      </div>

      <div className='subtitle ui vertical segment '>
        <div className='ui text container'>
          <Subtitle
            color='#378EBD'
            title={TEXT.titleB}
            category='B'
            angle='-5'
          />
          <div className='ta text'>{TEXT.textB}</div>
          <Stack category='B' lang={LOCALE} />
        </div>
      </div>

      <div className='subtitle ui vertical segment'>
        <div className='ui text container'>
          <Subtitle
            color='#9E272F'
            title={TEXT.titleC}
            category='C'
            angle='5'
          />
          <div className='ta text'>{TEXT.textC}</div>
          <Stack category='C' lang={LOCALE} />
        </div>
      </div>

      <div className='subtitle ui vertical segment'>
        <div className='ui text container'>
          <Subtitle
            color='#356D48'
            title={TEXT.titleD}
            category='D'
            angle='-5'
          />
          <div className='ta text'>{TEXT.textD}</div>
          <Stack category='D' lang={LOCALE} />
        </div>
      </div>

      <Footer
        articleId={ARTICLE_ID}
        credits={[
          [TEXT.credits[0], 'Bernhard Odenhnal, Sylvain Besson'],
          [TEXT.credits[1], 'Svenson Cornehls']
        ]}
        mailTo='daten@tamedia.ch'
      >
        <div
          className='ui container'
          style={{ margin: isMobile ? '1.2em 0 3em' : '0 0 3em' }}
        >
          <h4 className='teaser'>Weitere Beiträge zu den Pandora Papers</h4>
          <ArticleTeasers
            numberOfCards='three'
            articleIds={['969592328612', '443933016110', '307537397299']}
          />
        </div>
      </Footer>
    </div>
  )
}
